import { Injectable } from '@angular/core';

@Injectable()
export class ThemeService {
  private readonly key = 'theme';
  public isDark: boolean = false;

  /** Read the stored preference (or fall back to the OS setting) and apply it. */
  public init() {
    const saved = localStorage.getItem(this.key);
    // light-first design; only go dark when explicitly chosen
    this.apply(saved === 'dark');
  }

  public toggle() {
    this.apply(!this.isDark);
  }

  private apply(dark: boolean) {
    this.isDark = dark;
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem(this.key, dark ? 'dark' : 'light');
  }
}
